export enum SubscriptionPlanType {
    BasicPlan = 1,
    StandardPlan = 2,
    PremiumPlan = 3,
    EnterprisePlan = 4
}

export const SubscriptionPlanLabels = {
    [SubscriptionPlanType.BasicPlan]: 'Basic Plan',
    [SubscriptionPlanType.StandardPlan]: 'Standard Plan',
    [SubscriptionPlanType.PremiumPlan]: 'Premium Plan',
    [SubscriptionPlanType.EnterprisePlan]: 'Enterprise Plan'
};
